import React from "react"
import {Modal,ModalBody,ModalHeader,ModalFooter} from "reactstrap"
export default (props)=>{

return (<Modal     isOpen={props.isOpen} >
    
    <ModalBody style={{textAlign:"center"}}>{props.message||"..."}</ModalBody>
</Modal> );

}